// AUTO-GENERATED by scripts/build-icons.mjs — do not edit by hand.
import { createSvgIconFromGenerated } from '../utils'

import SvgFacebook from './svg-facebook'
import SvgInstagram from './svg-instagram'
import SvgLinkedin from './svg-linkedin'
import SvgYoutube from './svg-youtube'

export const FacebookIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgFacebook, 'Facebook')
export const InstagramIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgInstagram, 'Instagram')
export const LinkedinIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgLinkedin, 'Linkedin')
export const YoutubeIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgYoutube, 'Youtube')
